import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { initGoogleAuth } from './services/googleAuth'

// Import Tailwind CSS
import './assets/styles/tailwind.css'
// Import central CSS
import './assets/styles/global.css'

const app = createApp(App)

app.use(router)

// Global PWA install prompt handler
window.deferredInstallPrompt = null
window.addEventListener('beforeinstallprompt', (e) => {
  console.log('[PWA] beforeinstallprompt event fired (global)')
  e.preventDefault()
  window.deferredInstallPrompt = e
})

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('[PWA] Service Worker registered:', registration.scope)
        
        // Auto-update when new version available
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('[PWA] New version available, will update on next load')
              // Tell new service worker to skip waiting
              newWorker.postMessage({ type: 'SKIP_WAITING' })
            }
          })
        })
        
        // Check for updates every 30 minutes
        setInterval(() => {
          registration.update()
        }, 30 * 60 * 1000)
      })
      .catch((error) => {
        console.log('[PWA] Service Worker registration failed:', error)
      })
  })
  
  // Handle controller change (new SW activated)
  let refreshing = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true
      console.log('[PWA] New version activated, reloading...')
      window.location.reload()
    }
  })
}

// Initialize Google Auth before mounting app
initGoogleAuth().then(() => {
  app.mount('#app')
})
